/**
 * mdlondon Promotional Banner System
 * Displays dismissible promotional messages
 */

class PromotionalBannerManager {
  constructor() {
    this.storageKey = 'mdlondon_dismissed_banners';
    this.dismissedBanners = this.loadDismissedBanners();
    this.init();
  }

  init() {
    this.initializeBanners();
    this.setupEventListeners();
  }

  setupEventListeners() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('.promo-banner__close')) {
        e.preventDefault();
        this.dismissBanner(e.target.closest('.promo-banner__close'));
      }
    });
  }

  initializeBanners() {
    const banners = document.querySelectorAll('.promo-banner[data-banner-id]');
    banners.forEach(banner => {
      const bannerId = banner.dataset.bannerId;
      if (this.isBannerDismissed(bannerId)) {
        banner.remove();
      } else {
        banner.style.display = 'block';
      }
    });
  }

  dismissBanner(button) {
    const banner = button.closest('.promo-banner');
    const bannerId = banner.dataset.bannerId;

    banner.classList.add('promo-banner--dismissed');

    setTimeout(() => {
      banner.remove();
    }, 300);

    this.addDismissedBanner(bannerId);
  }

  isBannerDismissed(bannerId) {
    return this.dismissedBanners.includes(bannerId);
  }

  addDismissedBanner(bannerId) {
    if (!this.dismissedBanners.includes(bannerId)) {
      this.dismissedBanners.push(bannerId);
      this.saveDismissedBanners();
    }
  }

  loadDismissedBanners() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      return [];
    }
  }

  saveDismissedBanners() {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(this.dismissedBanners));
    } catch (error) {
      console.error('Error saving dismissed banners:', error);
    }
  }
}

new PromotionalBannerManager();
